"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextMonthYear = exports.getPreviousMonthYear = exports.isDateInMonthYearRange = exports.isTaxYearTraditional = exports.subtractMonths = exports.addMonths = exports.getEndOfDay = exports.getFirstDayOfTheMonth = exports.getLastDayOfTheMonth = exports.getMonthLongAbbreviation = exports.getMonthShortAbbreviation = exports.placedInServiceDate = exports.isStandardFiscalYear = exports.getFirstDayOfPeriodByLastDay = exports.removeZeroPadding = exports.addZeroPadding = exports.isAfterInitialTaxDeadline = exports.toIsoDateString = exports.currentDateToIsoString = exports.getLastDayOfTheYear = exports.sameDateString = exports.isLeapYear = exports.upperBoundForTaxReturnFilingDate = exports.getEndOfYear = exports.getStartOfYear = exports.getEntryForTaxYear = exports.getEntryForCurrentTaxYear = exports.getYearFromStringDate = exports.isDateString = exports.isDatetime = exports.getDatetime = exports.getCurrentDatetime = exports.getCurrentYear = exports.getCurrentDateObject = exports.getCurrentDate = exports.longDateFormat = exports.americanDateFormat = exports.formatDate = exports.formatDayjs = exports.endOfFiscalYearDate = exports.getCurrentTaxYear = exports.getExtensionTaxDeadline = exports.getInitialTaxDeadline = exports.isYyyyMmDd = exports.dateToDayjs = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const isLeapYear_1 = __importDefault(require("dayjs/plugin/isLeapYear"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const enums_1 = require("./enums");
const errors_1 = require("./errors");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(isLeapYear_1.default);
// Only avoids Saturday and Sunday. Not Holidays.
const avoidWeekend = (date) => {
    if (date.get('day') === enums_1.DayOfWeek.SATURDAY) {
        return date.add(2, 'day');
    }
    if (date.get('day') === enums_1.DayOfWeek.SUNDAY) {
        return date.add(1, 'day');
    }
    return date;
};
const dateToDayjs = (date) => (0, dayjs_1.default)(date).utc();
exports.dateToDayjs = dateToDayjs;
const isYyyyMmDd = (date) => (0, dayjs_1.default)(date, 'YYYY-MM-DD').isValid();
exports.isYyyyMmDd = isYyyyMmDd;
// Gets the standard tax deadline (usually april 15th)
// Adds four months and 15 days to last day of period
// Moves forward if that day happens to be on a weekend
const getInitialTaxDeadline = (lastDayOfPeriod) => {
    if (!(0, exports.isYyyyMmDd)(lastDayOfPeriod)) {
        throw (0, errors_1.createError)('InvalidDate', `Input (${lastDayOfPeriod}) could not be parsed into a Dayjs object`);
    }
    const convertedLastDay = (0, exports.dateToDayjs)(lastDayOfPeriod);
    const deadline = convertedLastDay.add(4, 'month');
    const deadlineSetFifteen = deadline.set('date', 15).endOf('day');
    switch (deadlineSetFifteen.day()) {
        case enums_1.DayOfWeek.FRIDAY:
        case enums_1.DayOfWeek.SATURDAY:
            // Add 3 days if April 15 is Friday or Saturday -> Monday or Tuesday
            return deadlineSetFifteen.add(3, 'day');
        case enums_1.DayOfWeek.SUNDAY:
            // Add 2 days if April 15 is Sunday -> Tuesday
            return deadlineSetFifteen.add(2, 'day');
        default:
            return deadlineSetFifteen;
    }
};
exports.getInitialTaxDeadline = getInitialTaxDeadline;
// If lastDayOfPeriod is december 31st, we can assume the late tax deadline is October 15th
// Otherwise, we have to calculate 10 months and 15 days into the future
// If that date lands on a weekend, move it forward to a monday
// TODO: Check if national holiday and move it even further if so
/**
 * @param lastDayOfPeriod
 * lastDayOfPeriod should be in format: "YYYY-MM-DD"
 */
const getExtensionTaxDeadline = (lastDayOfPeriod) => {
    const deadline = (0, exports.getInitialTaxDeadline)(lastDayOfPeriod).add(6, 'month');
    return avoidWeekend(deadline);
};
exports.getExtensionTaxDeadline = getExtensionTaxDeadline;
// The current tax year (i.e., previous fiscal year) is determined by the
// following period:
//
// - If current date is after the extension tax deadline, the current tax year is the year of the first day of the period + 1
// - If it is before, the current tax year is the year of the first date of the period
// FYI- This does not work for short year. This simply subtracts 11 months days from the last day of period. Will need to update this
// To accept first day of period as well - https://linear.app/neo-tax/issue/NEO-3439/update-the-getcurrenttaxyear-to-take-in-firstdayofperiod
/**
 * @param lastDayOfPeriod
 * lastDayOfPeriod should be in format: "YYYY-MM-DD"
 */
const getCurrentTaxYear = (lastDayOfPeriod) => {
    const firstDayOfPeriod = (0, exports.getFirstDayOfPeriodByLastDay)(lastDayOfPeriod);
    const firstDayOfPeriodConverted = (0, exports.dateToDayjs)(firstDayOfPeriod);
    const firstDayOfPeriodYear = firstDayOfPeriodConverted.get('year');
    return firstDayOfPeriodYear;
};
exports.getCurrentTaxYear = getCurrentTaxYear;
const endOfFiscalYearDate = (endOfFiscalYearMonth, year) => dayjs_1.default
    .utc()
    .set('month', endOfFiscalYearMonth - 1) // Dayjs 0-indexes month
    .endOf('month')
    .set('year', year)
    .toDate();
exports.endOfFiscalYearDate = endOfFiscalYearDate;
// TODO: figure out where else this can be used in the code
const formatDayjs = (date) => date.format('YYYY-MM-DD');
exports.formatDayjs = formatDayjs;
const formatDate = (date) => dayjs_1.default.utc(date).format('YYYY-MM-DD');
exports.formatDate = formatDate;
const americanDateFormat = (date, options = { zeroPadded: true }) => (0, exports.dateToDayjs)(date).format(options.zeroPadded ? 'MM/DD/YYYY' : 'M/D/YYYY');
exports.americanDateFormat = americanDateFormat;
const longDateFormat = (date) => (0, exports.dateToDayjs)(date).format('MMMM D, YYYY');
exports.longDateFormat = longDateFormat;
const getCurrentDate = () => (0, exports.formatDayjs)(dayjs_1.default.utc());
exports.getCurrentDate = getCurrentDate;
const getCurrentDateObject = () => dayjs_1.default.utc().toDate();
exports.getCurrentDateObject = getCurrentDateObject;
const getCurrentYear = () => dayjs_1.default.utc().year();
exports.getCurrentYear = getCurrentYear;
// If the time is in UTC, add a Z directly after the time without a space. Z is the zone designator for the zero UTC offset.
// "09:30 UTC" is therefore represented as "09:30Z" or "T0930Z". "14:45:15 UTC" would be "14:45:15Z" or "T144515Z".
const getCurrentDatetime = () => `${dayjs_1.default.utc().format('YYYYMMDDTHHmmssSSS')}Z`;
exports.getCurrentDatetime = getCurrentDatetime;
const getDatetime = (date) => `${dayjs_1.default.utc(date).format('YYYYMMDDTHHmmssSSS')}Z`;
exports.getDatetime = getDatetime;
const isDatetime = (date) => (0, dayjs_1.default)(date.substring(0, date.length - 1), 'YYYYMMDDTHHmmssSSS').isValid();
exports.isDatetime = isDatetime;
const isDateString = (date) => new Date(date).toString() != 'Invalid Date';
exports.isDateString = isDateString;
const getYearFromStringDate = (date) => {
    if (!(0, exports.isDateString)(date)) {
        throw (0, errors_1.createError)('InvalidDate', `Input (${date}) could not be parsed into a Date object`);
    }
    return new Date(date).getUTCFullYear();
};
exports.getYearFromStringDate = getYearFromStringDate;
const getEntryForCurrentTaxYear = (entries, lastDayOfPeriod) => (0, exports.getEntryForTaxYear)(entries, (0, exports.getCurrentTaxYear)(lastDayOfPeriod));
exports.getEntryForCurrentTaxYear = getEntryForCurrentTaxYear;
const getEntryForTaxYear = (entries, year) => entries.find((e) => e.year === year) || null;
exports.getEntryForTaxYear = getEntryForTaxYear;
const getStartOfYear = (year) => `${year}-01-01`;
exports.getStartOfYear = getStartOfYear;
const getEndOfYear = (year) => `${year}-12-31`;
exports.getEndOfYear = getEndOfYear;
// Return whichever date is earlier: the current date, or Oct 17th for the `year` passed in
const upperBoundForTaxReturnFilingDate = (lastDayOfPeriod) => {
    const currentDate = dayjs_1.default.utc();
    const toReturn = currentDate.isBefore((0, exports.getExtensionTaxDeadline)(lastDayOfPeriod))
        ? currentDate
        : (0, exports.getExtensionTaxDeadline)(lastDayOfPeriod);
    return toReturn;
};
exports.upperBoundForTaxReturnFilingDate = upperBoundForTaxReturnFilingDate;
const isLeapYear = (year) => (0, dayjs_1.default)(`${year}-01-01`).isLeapYear();
exports.isLeapYear = isLeapYear;
const sameDateString = (a, b) => (0, dayjs_1.default)(a).diff((0, dayjs_1.default)(b)) === 0;
exports.sameDateString = sameDateString;
const getLastDayOfTheYear = (date) => {
    const lastDayOfTheYear = new Date(date); // to keep all other values the same
    // december 31st
    lastDayOfTheYear.setUTCMonth(11);
    lastDayOfTheYear.setUTCDate(31);
    return lastDayOfTheYear;
};
exports.getLastDayOfTheYear = getLastDayOfTheYear;
const currentDateToIsoString = () => dayjs_1.default.utc().toDate().toISOString();
exports.currentDateToIsoString = currentDateToIsoString;
/**
 * @param date Date object
 * @returns String with date in ISO format (YYYY-MM-DD)
 */
const toIsoDateString = (date) => date.toISOString().split('T')[0];
exports.toIsoDateString = toIsoDateString;
/**
 * @param date {Date} Defaults to current date if no value supplied
 * @returns {boolean} True if date is after the initial tax deadline for the year, otherwise false
 */
const isAfterInitialTaxDeadline = (lastDayOfPeriod, date = new Date()) => {
    const initialTaxDeadline = (0, exports.getInitialTaxDeadline)(lastDayOfPeriod);
    return (0, dayjs_1.default)(date).isAfter(initialTaxDeadline);
};
exports.isAfterInitialTaxDeadline = isAfterInitialTaxDeadline;
/**
 * Takes a string and adds zero in the beginning if value is a single digit. This ensures months/days will always be two characters long.
 * e.g '1' turns into '01'
 * @param monthOrDay string representation of a month or day. Not zero indexed. (1-12 for month) (1-31 for day)
 * @returns {string} returns value but adds zero padding if needed
 */
const addZeroPadding = (monthOrDay) => (0 + monthOrDay).slice(-2);
exports.addZeroPadding = addZeroPadding;
const removeZeroPadding = (zeroPaddedMonthOrDay) => parseInt(zeroPaddedMonthOrDay).toString();
exports.removeZeroPadding = removeZeroPadding;
// Works only when assuming a full 12 month fiscal year
const getFirstDayOfPeriodByLastDay = (lastDayOfPeriod) => {
    const lastDayConverted = (0, dayjs_1.default)(lastDayOfPeriod).utc();
    return lastDayConverted.subtract(11, 'months').startOf('month').toISOString();
};
exports.getFirstDayOfPeriodByLastDay = getFirstDayOfPeriodByLastDay;
// This function expects YYYY-MM-DD format because we save the date that way in our database
const isStandardFiscalYear = (startDate, endDate) => {
    if (!(0, exports.isYyyyMmDd)(startDate) || !(0, exports.isYyyyMmDd)(endDate)) {
        throw (0, errors_1.createError)('InvalidDate', `Input (startDate: ${startDate} or endDate: ${endDate}) is not YYYY-MM-DD format.`);
    }
    return startDate.endsWith('01-01') && endDate.endsWith('12-31');
};
exports.isStandardFiscalYear = isStandardFiscalYear;
// "placed in service date" refers to the date when an asset is ready and
// available for use in its intended function or purpose. It is an important
// concept for tax purposes as it determines when certain tax benefits and
// deductions related to the asset begin.
const placedInServiceDate = (endDate) => (0, exports.dateToDayjs)(endDate).subtract(6, 'months').toDate();
exports.placedInServiceDate = placedInServiceDate;
/**
 * Get the 3-letter month abbreviation (Jan, Feb, ...)
 * @param month - value of the month to get abbreviation for (range 0 ~ 11)
 * @returns the month abbreviation
 */
const getMonthShortAbbreviation = (month) => {
    const date = new Date();
    date.setDate(1);
    return Intl.DateTimeFormat('en-US', { month: 'short' }).format(date.setMonth(month));
};
exports.getMonthShortAbbreviation = getMonthShortAbbreviation;
const getMonthLongAbbreviation = (month) => {
    const date = new Date();
    date.setDate(1);
    return Intl.DateTimeFormat('en-US', { month: 'long' }).format(date.setMonth(month));
};
exports.getMonthLongAbbreviation = getMonthLongAbbreviation;
const getLastDayOfTheMonth = (date) => {
    const lastDayOfTheMonth = new Date(date); // to keep all other values the same
    // set date to the 1st to prevent overflow, for example Jan 31st + 30 days = March 3rd.
    lastDayOfTheMonth.setUTCDate(1);
    lastDayOfTheMonth.setUTCMonth(date.getUTCMonth() + 1);
    lastDayOfTheMonth.setUTCDate(0); // setting to 0 reverses by one day
    return lastDayOfTheMonth;
};
exports.getLastDayOfTheMonth = getLastDayOfTheMonth;
const getFirstDayOfTheMonth = (date) => {
    const firstDayOfTheMonth = new Date(date); // to keep all other values the same
    firstDayOfTheMonth.setUTCDate(1);
    return firstDayOfTheMonth;
};
exports.getFirstDayOfTheMonth = getFirstDayOfTheMonth;
const getEndOfDay = (date = new Date()) => {
    const datetime = new Date(date);
    datetime.setUTCHours(23, 59, 59, 999);
    return datetime;
};
exports.getEndOfDay = getEndOfDay;
const addMonths = (date, numberMonths) => {
    let datejs = (0, dayjs_1.default)(date).utc();
    datejs = datejs.add(numberMonths, 'month');
    return datejs.format('YYYY-MM-DD');
};
exports.addMonths = addMonths;
const subtractMonths = (date, monthCount) => (0, dayjs_1.default)(date).utc().subtract(monthCount, 'month').toDate();
exports.subtractMonths = subtractMonths;
const isTaxYearTraditional = ({ firstDayOfPeriod, lastDayOfPeriod, }) => {
    const firstDay = (0, exports.dateToDayjs)(firstDayOfPeriod).utc();
    const lastDay = (0, exports.dateToDayjs)(lastDayOfPeriod).utc();
    return (firstDay.get('month') === 0 &&
        firstDay.get('date') === 1 &&
        lastDay.get('month') === 11 &&
        lastDay.get('date') === 31);
};
exports.isTaxYearTraditional = isTaxYearTraditional;
const isDateInMonthYearRange = (date, startMonthYear, endMonthYear) => {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth(); // JavaScript months are 0-indexed, and we use 0 indexed month in MonthYear
    if (year < startMonthYear.year || year > endMonthYear.year) {
        return false;
    }
    if (year === startMonthYear.year && month < startMonthYear.month) {
        return false;
    }
    if (year === endMonthYear.year && month > endMonthYear.month) {
        return false;
    }
    return true;
};
exports.isDateInMonthYearRange = isDateInMonthYearRange;
const getPreviousMonthYear = (monthYear) => ({
    month: monthYear.month === 0 ? 11 : monthYear.month - 1,
    year: monthYear.month === 0 ? monthYear.year - 1 : monthYear.year,
});
exports.getPreviousMonthYear = getPreviousMonthYear;
const getNextMonthYear = (monthYear) => ({
    month: monthYear.month === 11 ? 0 : monthYear.month + 1,
    year: monthYear.month === 11 ? monthYear.year + 1 : monthYear.year,
});
exports.getNextMonthYear = getNextMonthYear;
